<template>
  <b-breadcrumb :items="items"></b-breadcrumb>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          text: "Image",
          href: "#",
        },
        {
          text: "Folder1",
          href: "#",
        },
        {
          text: "SubFolder1",
          active: true,
        },
      ],
    };
  },
};
</script>
